import { purchaseActions } from "modules/purchase";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "store";

import type { Store } from "store";

type UseOrderTransactionInput = {
  orderId: string;
};

type UseOrderTransactionOutput = {
  transaction?: Store["purchase"]["activeTransactionMap"][string];
  isLoadingTransaction: boolean;
  isInvalidTransaction: boolean;
};

export const useOrderTransaction = (
  input: UseOrderTransactionInput
): UseOrderTransactionOutput => {
  const { orderId } = input;
  const dispatch = useDispatch();
  const activeTransactionMap = useSelector(
    (state: Store) => state.purchase.activeTransactionMap
  );

  useEffect(() => {
    dispatch(purchaseActions.fetchUserActiveTransactions.started());
  }, [dispatch]);

  const transaction = useMemo(() => {
    if (!activeTransactionMap) return undefined;
    const targetTransaction = activeTransactionMap[String(orderId)];
    return targetTransaction;
  }, [activeTransactionMap, orderId]);

  const isLoadingTransaction = !activeTransactionMap;
  const isInvalidTransaction = !isLoadingTransaction && !transaction;

  return {
    transaction,
    isLoadingTransaction,
    isInvalidTransaction,
  };
};
